import { useContext, useEffect, useState } from "react";
import User from "../../models/user";
import UserContext from "../../contexts/userContext";
import subscriptionService from "../../services/subscriptionService";
import SubscriptionStats from "../../models/subscriptionStats";
import SubscriptionContextModel from "../../contexts/subscriptionContextModel";
import SubscriptionContext from "../../contexts/subscriptionContext";
import Page from "../../components/work/layout/Page";
// import WelcomeImage from "../../assets/img/illustrations/welcome.svg";

const Dashboard: React.FC = () => {
  const user = useContext<User | undefined>(UserContext);
  const { subscription } =
    useContext<SubscriptionContextModel>(SubscriptionContext);

  const [subscriptionStats, setSubscriptionStats] = useState<SubscriptionStats>(
    new SubscriptionStats(),
  );

  useEffect(() => {
    const init = async () => {
      if (user) {
        const { data: subscriptionStats } =
          await subscriptionService.getSubscriptionStats(
            subscription.idSubscription,
          );

        setSubscriptionStats(subscriptionStats);
      }
    };

    init();
  }, [user, subscription]);

  return (
    <Page
      pageTitle="Dashboard"
      breadcrumbs={[{ linkName: "Dashboard", linkUlr: "" }]}
    >
      {/* <!-- Welcome & Stats Row --> */}
      <div className="row g-4 mb-4">
        {/* <!-- Welcome Card --> */}
        {/* <div className="col-12 col-xxl-5">
          <div className="card welcome-card h-100">
            <div className="card-body d-flex align-items-center">
              <div className="welcome-content">
                <p className="welcome-greeting">Good day,</p>
                <h3 className="welcome-name">David Dev!</h3>
                <div className="welcome-date">
                  <i className="bi bi-calendar3"></i>
                  <span id="currentDate">Jan 23, 2026</span>
                  <i className="bi bi-clock ms-3"></i>
                  <span id="currentTime">15:43:08</span>
                </div>
              </div>
              <div className="welcome-illustration">
                <img
                  src={WelcomeImage}
                  alt="Welcome"
                  // onerror="this.style.display='none'"
                />
              </div>
            </div>
          </div>
        </div> */}

        {/* <!-- Accounts --> */}
        <div className="col-12 col-md-4 col-xxl">
          <div className="card stat-card card-lift h-100">
            <div className="card-body">
              <div className="stat-card-header">
                <span className="stat-card-label">Accounts</span>
                <div className="stat-card-icon primary">
                  <i className="bx bxs-contact"></i>
                </div>
              </div>
              <div className="stat-card-value">
                {subscriptionStats.accountsCount}
              </div>
              {/* <div className="stat-card-change positive">
                <i className="bi bi-arrow-up"></i> 1.89%{" "}
                <span>Since last month</span>
              </div> */}
            </div>
          </div>
        </div>

        {/* <!-- Locations --> */}
        <div className="col-12 col-md-4 col-xxl">
          <div className="card stat-card card-lift h-100">
            <div className="card-body">
              <div className="stat-card-header">
                <span className="stat-card-label">Locations</span>
                <div className="stat-card-icon primary">
                  <i className="bi bi-house-door-fill"></i>
                </div>
              </div>
              <div className="stat-card-value">
                {subscriptionStats.locationsCount}
              </div>
              {/* <div className="stat-card-change positive">
                <i className="bi bi-arrow-up"></i> 5.23%{" "}
                <span>Since last month</span>
              </div> */}
            </div>
          </div>
        </div>

        {/* <!-- Service Providers --> */}
        <div className="col-12 col-md-4 col-xxl">
          <div className="card stat-card card-lift h-100">
            <div className="card-body">
              <div className="stat-card-header">
                <span className="stat-card-label">Service Providers</span>
                <div className="stat-card-icon primary">
                  <i className="bx bxs-briefcase"></i>
                </div>
              </div>
              <div className="stat-card-value">
                {subscriptionStats.serviceProvidersCount}
              </div>
              {/* <div className="stat-card-change positive">
                <i className="bi bi-arrow-up"></i> 4.87%{" "}
                <span>Since last month</span>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Dashboard;
